const getters = {
  // website: state => state.common.website,
  browserHeaderTitle: state => state.app.browserHeaderTitle
  // errorLogs: state => state.errorLog.logs

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js